import React from 'react';
import { Box, Hint, RoundBlockIcon, Text } from '@common-fe/common-fe';

interface Props {
  contactEmail?: string | React.ReactNode;
}

const UnverifiedContactHint: React.FC<Props> = ({ contactEmail }) => {
    return (
      <Box width="fit-content">
        <Hint
          hintAlign="vertical"
          hintWidth="fit-content"
          hintElement={(
            <Box direction="row" align="center">
              <Text color="danger">{contactEmail}</Text>
              <RoundBlockIcon size="16px" color="danger" />
            </Box>
          )}
        >
          <Text size="small">
            Email is not verified
          </Text>
        </Hint>
      </Box>
    );
};

export default UnverifiedContactHint;
